import { ReactElement, useEffect } from "react";
import { ModalFrame } from "../ModalFrame";
import { ModalContentProps } from "../../../../hooks/UseModal";
import { Card } from "../../Card";
import Loader from "../../Loader";
import * as styles from "./LoadingModal.module.scss";

export interface ILoadingModalProps {
    content: string;
}

export function LoadingModal(props: ModalContentProps<ILoadingModalProps, boolean>): ReactElement {
    return (
        <ModalFrame onClose={() => props.onClose(true)} useCard={false}>
            <div className={styles.modalContainer}>
                <Card>
                    <div className={styles.modalContent}>
                        <Loader loadingText={props.content} />
                    </div>
                </Card>
            </div>
        </ModalFrame>
    );
}
